import React, { useMemo, ReactElement } from 'react'
import { View, StyleProp, ViewStyle } from 'react-native'
import { responsivePositioningOptions } from '@adalo/constants'

import { RunnerObject } from 'types'

const { RIGHT } = responsivePositioningOptions

export interface VariableHeightWrapperProps {
  child: ReactElement
  object: RunnerObject
  positioningLayout: any
}

export const VariableHeightWrapper = ({
  child,
  object,
  positioningLayout,
}: VariableHeightWrapperProps): ReactElement => {
  const { responsivity } = object

  const rightAdjustment = useMemo(
    () =>
      responsivity?.horizontalPositioning === RIGHT
        ? rightVariableHeightStyles
        : {},
    [responsivity?.horizontalPositioning]
  )

  return (
    <View
      pointerEvents="box-none"
      style={[positioningLayout, variableHeightStyles, rightAdjustment]}
    >
      {child}
    </View>
  )
}

const variableHeightStyles: StyleProp<ViewStyle> = {
  width: '100%',
  position: 'absolute',
}

const rightVariableHeightStyles: StyleProp<ViewStyle> = {
  display: 'flex',
  justifyContent: 'flex-end',
  flexDirection: 'row',
}

export default VariableHeightWrapper
